<template>
  <div id="app">
   
        <!-- 头部自定义组件 -->
        <my-header></my-header>

        <router-view/>

        <!-- 底部自定义组件 -->
        <my-footer></my-footer>
         
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/App.vue